import React from 'react';
import SnackBar from '../../../SnackBar/SnackBar';
import Button from '../../../Buttons/Button';
import { customGaEvent, GA_EVENTS } from '../../../../utils/ga';

const TrialTierBanner = ({
  tier,
  publicTour,
  toggleC3DDescription,
  viewC3DDescription,
}) => {
  const makeTourClick = () => {
    customGaEvent({
      action: GA_EVENTS.TRIAL_MAKE_OWN_TOUR,
      label: 'clicked',
    });
  };

  const functionalityClick = () => {
    customGaEvent({
      action: GA_EVENTS.TRIAL_EXPLORE_FULL,
      label: 'clicked',
    });
  };

  return (
    <SnackBar
      inProp={(tier === 'starter' || tier === 'trial') && publicTour}
      position="bottomCenter"
      bottomCenter={{
        bottom: 0,
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
      classNames="starter"
    >
      <div className="c3d-info-wrapper">
        <p className="c3d-description-desktop" tabIndex={0}>
          Concept3D creates location-driven virtual experiences that engage your
          <br />
          viewers, showcase your location, and effectively tell your story.
        </p>
        <div className="c3d-btns">
          <a
            eventLabel="make your own tour"
            target="_blank"
            rel="noopener noreferrer"
            href="https://tour.concept3d.com"
            className="green-btn"
            onClick={makeTourClick}
          >
            Make your own tour
          </a>
          <a
            eventLabel="explore full functionality"
            target="_blank"
            rel="noopener noreferrer"
            href="https://concept3d.com/use-cases/product-page-360o-tours/"
            className="text-btn"
            onClick={functionalityClick}
          >
            <i className="material-icons">launch</i> Explore full functionality
          </a>
          <Button className="help-btn" handleClick={toggleC3DDescription}>
            <i className="material-icons">help</i>
          </Button>
        </div>
        {viewC3DDescription && (
          <p className="c3d-description">
            Concept3D creates location-driven virtual experiences that engage
            your viewers, showcase your location, and effectively tell your
            story.
          </p>
        )}
      </div>
    </SnackBar>
  );
};

export default TrialTierBanner;
